module.exports = __webpack_public_path__ + "img/solution-msil-function-icon-2.8c8cc5fc.svg";